var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsBoolean, IsDate, IsEnum, IsNotEmpty, IsNumber, IsOptional, IsString, } from 'class-validator';
import { DiscountType } from '../../../enums';
export class CreateD2CDiscountCodeDto {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateD2CDiscountCodeDto.prototype, "code", void 0);
__decorate([
    IsEnum(DiscountType),
    __metadata("design:type", String)
], CreateD2CDiscountCodeDto.prototype, "discountType", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateD2CDiscountCodeDto.prototype, "discountValue", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateD2CDiscountCodeDto.prototype, "maxDiscountAmount", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateD2CDiscountCodeDto.prototype, "minOrderAmount", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], CreateD2CDiscountCodeDto.prototype, "excludeSpecialContractFromDiscount", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], CreateD2CDiscountCodeDto.prototype, "isActive", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], CreateD2CDiscountCodeDto.prototype, "isCompanyIssued", void 0);
__decorate([
    IsDate(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateD2CDiscountCodeDto.prototype, "startDate", void 0);
__decorate([
    IsDate(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateD2CDiscountCodeDto.prototype, "endDate", void 0);
